import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { DeleteAccountConfirmPage } from './delete-account-confirm.page';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
  declarations: [DeleteAccountConfirmPage]
})
export class DeleteAccountConfirmPageModule {}
